import { useState } from "react";
import axios from "axios";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const submit = async () => {
    try {
      const res = await axios.post("https://haaterkaj-backend-1.onrender.com/api/admin/login", {
        email,
        password,
      });

      if (res.data.success) {
        localStorage.setItem("adminToken", res.data.token);
        window.location.href = "/admin/dashboard";
      } else {
        setError(res.data.message);
      }
    } catch (err) {
      setError("Login failed. Check email/password or server connection.");
      console.log(err);
    }
  };

  return (
    <div className="p-10 max-w-md mx-auto mt-10 border rounded shadow">
      <h2 className="text-3xl font-bold text-center mb-6">Admin Login</h2>

      {error && (
        <p className="bg-red-100 text-red-700 p-2 text-center rounded mb-3">
          {error}
        </p>
      )}

      <input
        className="border p-2 w-full mb-3 rounded"
        placeholder="Email"
        onChange={(e) => setEmail(e.target.value)}
      />

      <input
        className="border p-2 w-full mb-3 rounded"
        type="password"
        placeholder="Password"
        onChange={(e) => setPassword(e.target.value)}
      />

      <button
        onClick={submit}
        className="bg-amber-700 hover:bg-amber-800 text-white px-4 py-2 rounded w-full"
      >
        Login
      </button>

      {/* <p className="text-center text-sm mt-4">
        New Admin?{" "}
        <a href="/admin/signup" className="text-blue-600 underline">
          Create Account
        </a>
      </p> */}
    </div>
  );
}
